export const graphMixin = {
  computed: {
    smallScreen() {
      return document.documentElement.clientWidth < 550;
    },
    superSmallScreen() {
      return document.documentElement.clientWidth < 450;
    },
    graphWidth() {
      if (this.superSmallScreen) return 200;
      return this.smallScreen ? 400 : 500;
    }
  }
};
